export default "__VITE_ASSET__BJMO1CXL__"